const lineColors = [
  // default 8 colors
  { name: 'blue', value: '#107ef1' },
  { name: 'orange', value: '#f57f09' },
  { name: 'red', value: '#e3301b' },
  { name: 'yellow', value: '#ffd000' },
  { name: 'green', value: '#1aa023' },
  { name: 'blue-dark', value: '#0b4bb3' },
  { name: 'graphite', value: '#333333' },
  { name: 'silver', value: '#cccccc' },

  // colors used for comparison but in certain circumstances
  // can be used as custom color
  { name: 'violet', value: '#8547c5' },
  { name: 'teal', value: '#00c4c1' },
  { name: 'cyan', value: '#00D8FF' },
  { name: 'pink', value: '#F65CD2' },

  // additional dark versions
  { name: 'blue-dark', value: '#0b4bb3' },
  { name: 'orange-dark', value: '#ba5d00' },
  { name: 'red-dark', value: '#bb210f' },
  { name: 'yellow-dark', value: '#bf9c00' },
  { name: 'green-dark', value: '#0c6C13' },
  { name: 'violet-dark', value: '#662ba3' },
  { name: 'teal-dark', value: '#008280' },
  { name: 'cyan-dark', value: '#165B77' },
  { name: 'pink-dark', value: '#73195E' },
];

export default lineColors;
